package com.anjuros.website.templates.template10.modules

import com.anjuros.website.templates.template10.util.ResKey

enum class Template10Benefit(
    val glyph: String,
    val pinyin: String,
    val title: ResKey,
    val description: ResKey,
    val highlighted: Boolean
) {
    Balance(glyph = "衡", pinyin = "HÉNG", title = ResKey.TEMPLATE10_INFO_TITLE1, description = ResKey.TEMPLATE10_INFO_DESC1, highlighted = false),
    Calm(glyph = "静", pinyin = "JÌNG", title = ResKey.TEMPLATE10_INFO_TITLE2, description = ResKey.TEMPLATE10_INFO_DESC2, highlighted = true),
    Strength(glyph = "柔", pinyin = "RÓU", title = ResKey.TEMPLATE10_INFO_TITLE3, description = ResKey.TEMPLATE10_INFO_DESC3, highlighted = false)
}
